export const contact = {
  resumeTitle: "Get resume",
  email: "pablo.g.leyva@gmail.com",
  emailBtnText: "Send me an email",
  title: "Project or work inquiries? Let's get in touch!",
  emailHref: "mailto:pablo.g.leyva@gmail.com?subject=Hey%20Pablo!",
  pdfHref: "https://drive.google.com/file/d/1s-YPNvuP8EfznHkT7hVZjbTMCFr1ejhr/view?usp=share_link",
}
